const Row = ({
  interaction,
  mode,
  editable,
  editedScores,
  loadingUpdate,
  handleScoreChange,
}) => {
  const scoreValue = String(interaction?.Score ?? '').split('.')[0];
  const date = interaction?.dateRegister?.split('T')[0] ?? '';

  return (
    <tr
      className={`
        flex w-full
        ${!interaction ? 'min-h-[80px]' : 'hover:bg-gray-50 border-b border-gray-200'}
      `}
    >
      {mode !== 'resume' && (
        <td className="flex-[2] px-6 py-4 break-words text-md text-gray-500">
          {interaction?.type ?? ''}
        </td>
      )}
      <td className={`flex-[3] min-w-0 px-6 break-words ${mode === 'resume' ? 'py-3' : 'py-4'}`}>
        <div className={`flex flex-col ${mode === 'resume' ? 'gap-1' : 'gap-2'}`}>
          <span className={`${mode === 'resume' ? 'text-base' : 'text-lg'} font-medium`}>{interaction?.Name ?? ''}</span>
          {mode == 'resume' && (
            <span className="text-xs text-gray-500">
              {interaction?.type ?? ''}{date ? <>&nbsp;&bull;&nbsp;{date}</> : null}
            </span>
          )}
        </div>
      </td>
      {mode == 'modal' && (
        <td className="flex-[1] px-6 py-4 whitespace-nowrap text-md text-gray-500">
          {interaction?.dateRegister?.split('T')[0] ?? ''}
        </td>
      )}
      {mode == 'resume' && (
        <td className="flex-[1] px-6 py-4 whitespace-nowrap text-md font-semibold text-green-700">
          {interaction && (
            <span className="rounded-md border border-green-100 bg-green-50 px-2.5 py-1 text-sm text-green-600">
              +{scoreValue} pts
            </span>
          )}
        </td>
      )}
      {mode !== 'resume' && (
        <td className={`flex-[1] px-6 py-4 whitespace-nowrap text-md ${mode != 'principal' ? 'text-gray-500' : 'text-gray-900'}`}>
          {editable ? (
            <input
              type="text"
              value={
                editedScores[interaction?.Id] !== undefined
                  ? editedScores[interaction?.Id]
                  : interaction?.Score
              }
              onChange={(e) => handleScoreChange(interaction?.Id, e.target.value)}
              className="ml-1 w-10 px-2 py-1 border border-purple-500 rounded text-center bg-purple-100"
              disabled={loadingUpdate}
            />
          ) : (
            interaction ? scoreValue : ''
          )}
        </td>
      )}
    </tr>
  );
};

export default Row;
